// extracted by mini-css-extract-plugin
module.exports = {"bar":"ColourBar_bar__1mEud"};